import { useMemo } from 'react';
import { endpoints, fetcherSwr, poster, patcher, deleter } from '../utils/axios';
import useSWR from 'swr';

export function useGetFacilities(args = {}) {
  const hasParams = Object.keys(args).length > 0;
  const URL = hasParams ? [endpoints.facilities.getFacilities, { params: args }] : null;

  const { data, isLoading, error, isValidating, mutate } = useSWR(URL, fetcherSwr);

  return useMemo(
    () => ({
      facilities: data?.data || [],
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );
}

export const createFacility = async (body) => {
  try {
    return await poster(endpoints.facilities.createFacility, body);
  } catch (e) {
    return { success: false, message: e?.response?.data?.message || e.message };
  }
};

export const updateFacility = async (id, body) => {
  try {
    return await patcher(endpoints.facilities.updateFacility(id), body);
  } catch (e) {
    return { success: false, message: e?.response?.data?.message || e.message };
  }
};

export const deleteFacility = async (id) => {
  try {
    return await deleter(endpoints.facilities.deleteFacility(id));
  } catch (e) {
    return { success: false, message: e?.response?.data?.message || e.message };
  }
};
